import * as R from 'ramda';

import { useNavigation } from '@atom/hooks/useNavigation';
import { DashboardCard } from '@atom/types/dashboard';

import classes from '../dashboardCard.module.css';

interface Props {
  card: DashboardCard;
  cardData: { users: { totalCount: string } };
}

const CardPendingUserRequests = ({ card, cardData }: Props) => {
  const [, { Link }] = useNavigation();

  const display = R.pathOr(0, ['users', 'totalCount'], cardData);
  const style = {
    height: `${card.emptyHeight}px`,
    fontSize: '2.5rem',
  };
  return (
    <div style={style} className={classes.cardContent}>
      <Link target="_blank" to="/team?view=PENDING">
        {display}
      </Link>
    </div>
  );
};

export default CardPendingUserRequests;
